module.exports = "../../../../platform/assets/pageMainIcon/youth_danjuweihulei3.svg";